import {Action, combineReducers, Reducer} from "redux";
import {History} from "history";
import {connectRouter} from "connected-react-router";
import {AppState, WorkforceRoute} from "../AppState";
import Workforce1User from "./Workforce1User";
import Workforce1Companies from "./Workforce1Companies";


export interface RootReduceType extends Reducer<AppState, Action> {

}

const createRootReducer = (history: History<WorkforceRoute>): RootReduceType => {
    return combineReducers(
        {
            router: connectRouter(history),
            Workforce1State: Workforce1User,
            Workforce1Companies: Workforce1Companies,
        }
    );
};
export default createRootReducer;
